import React, { Component } from 'react';
import { Button, Modal, FormGroup, FormControl, Checkbox } from 'react-bootstrap';
import './sign-in-form.css';

export class SignInForm extends Component {

  constructor() {
    super(...arguments);
    this.state = {
      email: '',
      password: '',
      pwType: 'password',
      showModal: false,
    };

    this.updateEmail = this.updateEmail.bind(this);
    this.updatePassword = this.updatePassword.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.togglePassword = this.togglePassword.bind(this);
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
  }

  close() {
    this.setState({ showModal: false });
    this.clearInfo();
    this.props.clearError();
  }

  open() {
    this.setState({ showModal: true });
  }

  clearInfo () {
    this.setState({ email: '', password: '' });
  }

  updateEmail(event) {
    this.setState({email: event.target.value});
  }

  updatePassword(event) {
    this.setState({password: event.target.value});
  }

  togglePassword(event) {
    if (event.target.checked) {
      this.setState({ pwType: 'text' });
    } else {
      this.setState({ pwType: 'password' });
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    let email = this.state.email;
    let password = this.state.password;

    this.props.signInWithEmailAndPassword(email, password)
  }

  renderError() {
    if (this.props.loginError) {
      return (
        <div className='login-error-msg'>
          Invalid login credentials. Try again.
        </div>
      )
    }
  }

  render() {
    var errorMessage = this.renderError();

    return (
      <div >
        {/*<!-- Trigger the modal with a button -->*/}
        <Button bsStyle="primary" className="sign-in-btn" onClick={this.open}> 
          Login 
        </Button>
        {/*<!-- Modal -->*/}
        <Modal show={this.state.showModal} onHide={this.close}>
          <div className="modal-header">
            <h5 className="modal-title">Log in to continue</h5>
            <button type="button" className="close" onClick={this.close}>
              <span aria-hidden="true">×</span>
              <span className="sr-only">Close</span>
            </button>
          </div>

          <Modal.Body>
            {errorMessage}

            <form>
              <FormGroup>
                <FormControl
                  type="text"
                  value={this.state.email}
                  placeholder="Enter email"
                  onChange={this.updateEmail}
                />
              </FormGroup>

              <FormGroup>
                <FormControl
                  type={this.state.pwType}
                  value={this.state.password}
                  placeholder="Enter password"
                  onChange={this.updatePassword}
                />
              </FormGroup>

              <div className='login-misc'>
                <FormGroup>
                  <Checkbox inline>Remember me</Checkbox>
                  <Checkbox inline onClick={this.togglePassword}>
                    Show Password
                  </Checkbox>
                </FormGroup>
              </div>

              <Button 
                bsStyle="info"
                className='login-btn'
                data-dismiss="modal" 
                onClick={this.handleSubmit}
              >
                Log in
              </Button>
            </form>
          </Modal.Body>
        </Modal>
        
      </div>
    );
  }
}

export default SignInForm;


// WEBPACK FOOTER //
// ./src/views/components/sign-in-form/sign-in-form.js